var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),(_vm.displayViewerHeader)?_c('div',[_c('ToolsBar'),(_vm.study && _vm.currentUser !== null && _vm.canUserViewStudy)?_c('SideBars'):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }